import { useContext } from 'react';
import { EventConfig } from '@/eventConfig/EventConfigContext.tsx';
import { EventConfigApi } from '@/eventConfig/EventConfigProvider.tsx';

export const useEventConfig = (): EventConfigApi => {
  const context = useContext(EventConfig);
  if (context === null) {
    throw Error('Event Context not available');
  }
  return context;
};
